import "intersection-observer";
import "./polyfills";

// import './assets';

import { createComponent } from "@bigyouth/base";

import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks"; // lazyload bgs with data-bg

import "../scss/styles-global.scss";
import * as features from "./features/exports/global";

import setScrollbarSize from "./utils/setScrollbarSize";

Object.values(features).forEach(createComponent);

// remove preload class on body (prevent flash of transitions when page is loading)
document.addEventListener("DOMContentLoaded", function () {
  document.body.classList.remove("preload");
});

setScrollbarSize(); 

window.addEventListener("orientationchange", () => {
  setScrollbarSize();
});
